__turbopack_context__.v({
  "wrapper": "wkNlBG_wrapper",
});
